import styled from 'styled-components';
import { rem } from 'polished';

export const StyledProjectsTable = styled.div`
  width: 100%;
  .list-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .list {
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: dense;
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 12px;
    max-width: 270px;
    margin: ${rem(`24px`)} ${rem(`-6px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      margin: ${rem(`24px`)} ${rem(`-6px`)};
      grid-template-columns: repeat(3, 1fr);
      max-width: 100%;
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      margin: ${rem(`24px`)} ${rem(`-6px`)};
      grid-template-columns: repeat(4, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      margin: ${rem(`24px`)} ${rem(`-12px`)};
      grid-template-columns: repeat(5, 1fr);
      grid-row-gap: 24px;
    `}
  }
`;
